import { render, staticRenderFns } from "./EsgHome.vue?vue&type=template&id=bbfbc82a&scoped=true"
import script from "./EsgHome.vue?vue&type=script&lang=js"
export * from "./EsgHome.vue?vue&type=script&lang=js"
import style0 from "./EsgHome.vue?vue&type=style&index=0&id=bbfbc82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfbc82a",
  null
  
)

export default component.exports